<template>
  <div class="friend">
    <div class="new" @click="onNews" :class="{ flag: newList.length != 0 }">
      <icon class="icon" type="tongzhi"></icon>
      新的伙伴
    </div>
    <div class="list">
      <Row type="flex" :gutter="20">
        <Col :span="12" v-for="(item, index) in list" :key="index">
          <div class="item">
            <img :src="(item.user && item.user.avatarUrl) || avatar" alt />
            <div class="content">
              <div class="name">{{ item.user && item.user.name }} - {{ item.user && item.user.nickname }}</div>
              <div class="duty">{{ item.duty }}</div>
            </div>
            <div class="btn" @click="del(item, index)" v-if="item.userId !== userId">删除</div>
            <div class="btn" @click="del(item, index)" v-else>退出该企业</div>
          </div>
        </Col>
      </Row>
    </div>
    <Page :total="pagination.count" @on-change="changePage"></Page>
    <no-data v-if="list.length === 0">暂无数据</no-data>
    <Modal width="740" v-model="news" footer-hide title="新的伙伴申请">
      <div class="newlist">
        <div class="item" v-for="(item, index) in newList" :key="index">
          <img :src="item.user.avatarUrl || avatar" alt />
          <div class="content">
            <div class="name">{{ item.user.name }} - {{ item.user && item.user.nickname }}</div>
            <div class="duty">{{ item.duty }}</div>
          </div>
          <div class="btn" v-if="item.status === 0">
            <div @click="approve(item, 2)">拒绝</div>
            <div @click="approve(item, 1)">接受</div>
          </div>
          <div v-else-if="item.status === 1" class="jieshou">已接受</div>
          <div v-else-if="item.status === 2" class="jieshou">已拒绝</div>
        </div>
      </div>
      <no-data v-if="newList.length === 0">暂无数据</no-data>
    </Modal>
    <Modal v-model="showTransfer" title="转让主管理员并退出企业" footer-hide>
      <Form ref="quitForm" :model="quitForm" :rules="quitRules" :label-width="80">
        <FormItem label="转让给" prop="to">
          <Select v-model="quitForm.to">
            <Option v-for="item in allUsers" :value="item.id" :key="item.id">
              {{ item.user.name }} - {{ item.user && item.user.nickname }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="doTransfer">确定</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import avatar from '@/assets/images/avatar.png';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      showTransfer: false,
      list: [],
      quitForm: {},
      allUsers: [],
      newList: [],
      news: false,
      pagination: {},
      avatar: avatar,
      page: 1,
      quitRules: {
        to: [{ required: true, message: '请选择要转交的用户', trigger: 'blur', type: 'number' }]
      }
    };
  },
  watch: {
    news(val) {
      if (!val) {
        this.getList();
        this.getNews();
      }
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId
    })
  },
  mounted() {
    this.getList();
    this.getNews();
  },
  methods: {
    ...mapActions(['handleLogOut']),
    getList() {
      this.$axios
        .request({
          url: 'front/v1/company-user',
          params: {
            pageIndex: this.page
          }
        })
        .then(res => {
          this.list = res.data.list;
          this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
        });
    },
    doTransfer() {
      this.$refs.quitForm.validate(valid => {
        if (valid) {
          this.$axios
            .request({
              url: 'front/v1/company-user/del',
              data: this.quitForm,
              method: 'delete'
            })
            .then(res => {
              this.$Message.success('操作成功');
              this.showTransfer = false;
              this.getList();
              if (this.quitForm.userId == this.userId) {
                this.handleLogOut();
              }
            });
        }
      });
    },
    del(item, index) {
      let title = '确认删除该用户';
      if (item.userId === this.userId) {
        title = '确认要退出该企业';
        if (item.isMainAdmin === 1) {
          this.showTransfer = true;
          this.quitForm.id = item.id;
          this.quitForm.userId = item.userId;
          this.$axios
            .request({
              url: 'front/v1/company-user',
              params: {
                pageSize: 1000
              }
            })
            .then(res => {
              this.allUsers = [];
              res.data.list.forEach(item => {
                if (item.userId !== this.userId) {
                  this.allUsers.push(item);
                }
              });
            });
          return;
        }
      }
      this.$Modal.confirm({
        title: title,
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/company-user/del',
              data: { id: item.id },
              method: 'delete'
            })
            .then(res => {
              this.$Message.success('删除成功');
              this.getList();
              if (item.userId == this.userId) {
                this.handleLogOut();
              }
            });
        }
      });
    },
    changePage(page) {
      this.page = page;
      this.getList();
    },
    getNews() {
      this.$axios.request({ url: 'front/v1/company-user/application-list', params: { pageSize: 100 } }).then(res => {
        this.newList = res.data.list;
      });
    },
    onNews() {
      this.news = true;
    },
    approve(item, status) {
      this.$axios
        .request({
          url: 'front/v1/company-user/application/approve',
          method: 'post',
          data: { status: status, id: item.id }
        })
        .then(res => {
          item.status = status;
          this.$Message.success('操作成功');
        });
    }
  }
};
</script>

<style lang="less" scoped>
.friend {
  font-size: 14px;
  .new {
    width: 143px;
    height: 34px;
    background-color: #fff;
    color: #363e4f;
    display: flex;
    cursor: pointer;
    align-items: center;
    > .icon {
      margin: 0 10px 0 20px;
    }
  }
  .flag::after {
    content: '';
    display: flex;
    width: 8px;
    height: 8px;
    background: red;
    border-radius: 50%;
    margin-left: 11px;
  }
  > .list {
    margin-top: 12px;
    margin-bottom: 20px;
    .item {
      height: 100px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      background: #fff;
      > img {
        margin-left: 40px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
      }
      > .content {
        flex: 1;
        margin-left: 20px;
        .name {
          font-size: 18px;
          margin-bottom: 10px;
          font-weight: bold;
        }
        .position {
          opacity: 0.7;
        }
      }
      .btn {
        font-size: 14px;
        color: #d6000f;
        margin-right: 60px;
        cursor: pointer;
      }
    }
    .noData {
      text-align: center;
      opacity: 0.7;
    }
  }
}
.newlist {
  background: #000;
  .item {
    height: 100px;
    display: flex;
    align-items: center;
    background: #fff;
    border-bottom: 1px solid #eee;
    img {
      margin-left: 40px;
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
    > .content {
      flex: 1;
      margin-left: 20px;
      .name {
        font-size: 18px;
        margin-bottom: 10px;
      }
      .position {
        opacity: 0.7;
      }
    }
    .btn {
      margin-right: 30px;
      display: flex;
      > div {
        padding: 0px 30px;
        height: 36px;
        line-height: 36px;
        cursor: pointer;
      }
      > div:first-child {
        border: 1px solid #d6000f;
        color: #d6000f;
        margin-right: 20px;
      }
      > div:last-child {
        background: #d6000f;
        color: #fff;
      }
    }
    .jieshou {
      margin-right: 30px;
      height: 36px;
      line-height: 36px;
      padding: 0px 30px;
      background: rgba(54, 62, 79, 0.1);
      color: rgba(54, 62, 79, 0.3);
    }
  }
  .item:last-child {
    border: none;
  }
}
</style>
